<rt-infobox
  [heading]="'app.pricing.billing_page.subscription_future_infobox.heading' | translate"
  [isDismissible]="false"
  type="information"
  iconName="error"
  margin-bottom
>
  <p [innerHTML]="message"></p>
</rt-infobox>
